import { render, staticRenderFns } from "./AsACoachPage.vue?vue&type=template&id=61d78bfe&scoped=true"
import script from "./AsACoachPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AsACoachPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsACoachPage.vue?vue&type=style&index=0&id=61d78bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d78bfe",
  null
  
)

export default component.exports